module.exports = __webpack_public_path__ + "static/media/5.57e49486.jpg";